import { BaseApi, PassVersionMode } from '../base-api';

export class ChannelsActivityApi extends BaseApi {
  protected readonly version: number = 2;
  protected readonly passVersionMode: PassVersionMode = PassVersionMode.Header;
  protected readonly prefix = 'license/channels';

  fetch = () => this.get();
}
